





















































import Vue from 'vue';
import { Expression, AndExpression, NoExpression, OrExpression, NotExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<AndExpression>().extend({
  name: 'AndEditor',
  methods: {
    addAnd() {
      this.value.expressions.push(NoExpression.instance);
      this.update();
    },
    addOr() {
      this.input(new OrExpression([this.value, NoExpression.instance]));
    },
    addNot() {
      this.input(new NotExpression(this.value));
    },
    updateExpression(index: number, expr?: Expression) {
      if (expr) {
        this.$set(this.value.expressions, index, expr);
      } else {
        this.value.expressions.splice(index, 1);
      }

      const n = this.value.expressions.length;

      if (n === 1) {
        this.input(this.value.expressions[0]);
      } else if (n === 0) {
        this.remove();
      } else {
        this.update();
      }
    },
  },
});
